import { render, staticRenderFns } from "./ItemReports.vue?vue&type=template&id=0d8ee33b"
import script from "./ItemReports.vue?vue&type=script&lang=js"
export * from "./ItemReports.vue?vue&type=script&lang=js"
import style0 from "./ItemReports.vue?vue&type=style&index=0&id=0d8ee33b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports